<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row col-md-12">
        <v-card class="col-xl-3 col-lg-4 col-md-6 no-padding">
          <div class="col-md-12 text-center border-blue-bottom text-gray">
            <h3 class="mt-3 mb-3">Eligibility Check</h3>
          </div>
          <div class="col-md-12 pa-7">
            <div class="col-md-12 no-padding">
              <label class="font text-gray" for="">Payer ID</label>
              <v-text-field required solo v-model="payerId"></v-text-field>
            </div>
            <div class="col-md-12 no-padding">
              <label class="font text-gray" for="">Group ID</label>
              <v-text-field required solo v-model="groupId"></v-text-field>
            </div>
            <div class="col-md-12 no-padding">
              <label class="font text-gray" for="">Plan ID</label>
              <v-text-field required solo v-model="planId"></v-text-field>
            </div>
            <div class="col-md-12 no-padding">
              <label class="font text-gray" for="">Member ID</label>
              <v-text-field
                required
                solo
                hide-details
                v-model="memberId"
              ></v-text-field>
            </div>
          </div>
          <div class="col-md-12 pa-7">
            <div class="col-md-12 check-eligibility pointer" @click="check">
              <svg
                width="64"
                height="64"
                viewBox="0 0 54 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.7713 5.74543C24.1794 6.19751 24.6778 6.55892 25.2344 6.80627C25.7909 7.05363 26.3931 7.18144 27.0021 7.18144C27.6111 7.18144 28.2133 7.05363 28.7698 6.80627C29.3263 6.55892 29.8248 6.19751 30.2329 5.74543L32.3216 3.42968C32.9244 2.76457 33.718 2.30209 34.5938 2.10559C35.4696 1.90908 36.3847 1.98815 37.2138 2.33198C38.0429 2.6758 38.7455 3.26755 39.2253 4.02621C39.7052 4.78487 39.9388 5.67334 39.8942 6.56994L39.7342 9.68131C39.7033 10.2898 39.8003 10.898 40.0191 11.4667C40.2378 12.0353 40.5734 12.5518 41.0042 12.9826C41.435 13.4134 41.9513 13.7491 42.5198 13.9679C43.0884 14.1867 43.6965 14.2837 44.3049 14.2528L47.4157 14.0928C48.3145 14.0449 49.2061 14.2769 49.9676 14.7569C50.7291 15.2368 51.3231 15.941 51.6679 16.7725C52.0127 17.6041 52.0913 18.5221 51.8929 19.4002C51.6945 20.2783 51.2287 21.0732 50.5599 21.6756L48.2445 23.7647C47.7925 24.1729 47.4312 24.6714 47.1839 25.228C46.9366 25.7847 46.8088 26.387 46.8088 26.9961C46.8088 27.6052 46.9366 28.2075 47.1839 28.7641C47.4312 29.3208 47.7925 29.8193 48.2445 30.2275L50.5599 32.3165C51.2275 32.9189 51.6922 33.7132 51.8902 34.5904C52.0882 35.4676 52.0098 36.3846 51.6657 37.2155C51.3216 38.0463 50.7287 38.7501 49.9685 39.2303C49.2083 39.7105 48.3181 39.9435 47.4202 39.8972L44.3094 39.7372C43.701 39.7066 43.0931 39.8039 42.5247 40.0228C41.9563 40.2417 41.4401 40.5774 41.0094 41.0081C40.5787 41.4389 40.2431 41.9552 40.0243 42.5237C39.8054 43.0922 39.7081 43.7002 39.7387 44.3087L39.8987 47.42C39.9449 48.3181 39.712 49.2085 39.2319 49.9688C38.7518 50.7292 38.0481 51.3222 37.2174 51.6663C36.3867 52.0105 35.4699 52.0889 34.5929 51.8909C33.7158 51.6928 32.9216 51.228 32.3194 50.5603L30.2307 48.2445C29.8225 47.7925 29.3241 47.431 28.7676 47.1837C28.2111 46.9363 27.6089 46.8085 26.9999 46.8085C26.3909 46.8085 25.7886 46.9363 25.2321 47.1837C24.6756 47.431 24.1772 47.7925 23.7691 48.2445L21.6737 50.5625C21.0714 51.2302 20.2772 51.6951 19.4002 51.8931C18.5232 52.0912 17.6063 52.0127 16.7757 51.6685C15.945 51.3244 15.2413 50.7314 14.7612 49.971C14.2811 49.2107 14.0481 48.3203 14.0944 47.4222L14.2544 44.3109C14.2853 43.7024 14.1883 43.0941 13.9695 42.5255C13.7508 41.9568 13.4152 41.4404 12.9844 41.0096C12.5537 40.5787 12.0373 40.2431 11.4688 40.0243C10.9002 39.8055 10.2921 39.7084 9.68371 39.7394L6.57289 39.8994C5.67751 39.9419 4.79083 39.707 4.03398 39.2266C3.27713 38.7462 2.687 38.0439 2.34423 37.2155C2.00145 36.3871 1.92273 35.473 2.11883 34.5982C2.31492 33.7233 2.77627 32.9304 3.43985 32.3277L5.75519 30.2386C6.20719 29.8304 6.56853 29.3319 6.81585 28.7753C7.06316 28.2186 7.19095 27.6163 7.19095 27.0072C7.19095 26.3981 7.06316 25.7958 6.81585 25.2392C6.56853 24.6825 6.20719 24.184 5.75519 23.7758L3.43985 21.6868C2.77136 21.0846 2.30584 20.2901 2.10731 19.4124C1.90878 18.5348 1.98701 17.6172 2.33123 16.7859C2.67544 15.9546 3.26874 15.2503 4.0295 14.7701C4.79027 14.2898 5.68113 14.0571 6.57955 14.1039L9.69037 14.2639C10.2999 14.296 10.9094 14.1994 11.4792 13.9805C12.0489 13.7616 12.5663 13.4252 12.9976 12.9932C13.4289 12.5612 13.7644 12.0432 13.9825 11.473C14.2006 10.9028 14.2962 10.2931 14.2633 9.68353L14.1033 6.57216C14.0603 5.67644 14.2948 4.78927 14.7749 4.03191C15.255 3.27455 15.9573 2.68395 16.7856 2.34082C17.614 1.99769 18.5281 1.91878 19.403 2.11487C20.2779 2.31095 21.0709 2.77247 21.6737 3.43634L23.7713 5.74543Z"
                  stroke="#084BA7"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33.668 27.5162L20.3359 19.7044V35.3301L33.668 27.5162Z"
                  stroke="#084BA7"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <h4 class="blue-text" style="color: #084ba7">
                Check Eligibility
              </h4>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <v-dialog
      v-model.trim="dialog"
      height="293"
      width="400"
      
    >
      <v-card>
        <v-card-text>
          <div class="col-md-12">
            <div class="row text-center justify-center">
              <h3 class="text-center mt-5 mb-5 text-underline black--text">
                Eligibility Check
              </h3>
            </div>
          </div>
          <div class="col-md-12 text-center mt-3">
            <div class="green-success-modal">
              <svg
                width="44"
                height="44"
                viewBox="0 0 54 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M48.5241 20.7069C48.3196 21.4829 47.9038 22.1817 47.3262 22.7203L45.166 24.7383C44.7439 25.1323 44.4066 25.6134 44.1756 26.1507C43.9447 26.6879 43.8254 27.2693 43.8254 27.8573C43.8254 28.4452 43.9447 29.0266 44.1756 29.5639C44.4066 30.1012 44.7439 30.5823 45.166 30.9763L47.3262 32.9943C47.9495 33.5756 48.3833 34.3423 48.5682 35.189C48.753 36.0357 48.6797 36.9208 48.3584 37.7227C48.0371 38.5246 47.4835 39.2039 46.7738 39.6672C46.064 40.1305 45.233 40.3551 44.3948 40.3102L41.4878 40.1562C40.9203 40.1265 40.353 40.2202 39.8227 40.4314C39.2923 40.6426 38.8108 40.9665 38.409 41.3822C38.0073 41.7979 37.6944 42.2961 37.4904 42.8446C37.2865 43.3932 37.1961 43.9799 37.2252 44.5669L37.3741 47.5732C37.4191 48.4409 37.2029 49.3018 36.7552 50.0372C36.3074 50.7725 35.6503 51.3462 34.8741 51.6792C34.098 52.0123 33.2411 52.0882 32.4215 51.8966C31.6019 51.705 30.86 51.2553 30.2978 50.6094L28.3465 48.3753C27.9656 47.9389 27.5003 47.59 26.9808 47.3512C26.4613 47.1123 25.8991 46.9889 25.3306 46.9889C24.7621 46.9889 24.1999 47.1123 23.6804 47.3512C23.1609 47.59 22.6957 47.9389 22.3148 48.3753L20.3634 50.6094C19.8011 51.2544 19.0593 51.7033 18.2401 51.8943C17.4209 52.0854 16.5646 52.0092 15.789 51.6763C15.0134 51.3435 14.3566 50.7702 13.909 50.0354C13.4614 49.3006 13.2449 48.4404 13.2894 47.5732L13.445 44.5669C13.474 43.9797 13.3836 43.3928 13.1795 42.8441C12.9755 42.2953 12.6623 41.797 12.2603 41.3813C11.8584 40.9656 11.3765 40.6417 10.8459 40.4307C10.3153 40.2197 9.74781 40.1261 9.18008 40.1562L6.27311 40.3102C5.43493 40.3551 4.60385 40.1305 3.8941 39.6672C3.18436 39.2039 2.63079 38.5246 2.30948 37.7227C1.98818 36.9208 1.91491 36.0357 2.09974 35.189C2.28457 34.3423 2.71844 33.5756 3.3417 32.9943L5.50192 30.9763C5.92395 30.5823 6.26134 30.1012 6.49226 29.5639C6.72319 29.0266 6.8425 28.4452 6.8425 27.8573C6.8425 27.2693 6.72319 26.6879 6.49226 26.1507C6.26134 25.6134 5.92395 25.1323 5.50192 24.7383L3.3417 22.7203C2.719 22.1393 2.2854 21.3733 2.10044 20.5273C1.91547 19.6813 1.9882 18.7969 2.30863 17.9954C2.62907 17.1938 3.18151 16.5145 3.89013 16.0506C4.59876 15.5867 5.42884 15.361 6.26645 15.4044L9.17341 15.5584C9.74169 15.5894 10.3099 15.4967 10.8413 15.2861C11.3727 15.0755 11.8554 14.7518 12.2581 14.336C12.6608 13.9202 12.9746 13.4215 13.179 12.8722C13.3835 12.323 13.4741 11.7355 13.445 11.1477L13.2894 8.14139C13.2439 7.27375 13.4596 6.41288 13.9069 5.67732C14.3542 4.94177 15.0109 4.36771 15.7868 4.03421C16.5626 3.70072 17.4193 3.62419 18.239 3.81516C19.0586 4.00613 19.8008 4.45522 20.3634 5.10057L22.3148 7.33464C22.6953 7.77174 23.1604 8.12123 23.68 8.36046C24.1995 8.59969 24.7619 8.72332 25.3306 8.72332C25.8993 8.72332 26.4617 8.59969 26.9813 8.36046C27.5008 8.12123 27.9659 7.77174 28.3465 7.33464L30.2978 5.10057C30.8612 4.45814 31.603 4.01167 32.4215 3.82239C33.24 3.6331 34.095 3.71026 34.8694 4.04329"
                  stroke="#09951F"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.2227 23.5822L22.8077 31.2843C23.1087 31.6991 23.4964 32.0384 23.9418 32.2768C24.3873 32.5152 24.879 32.6466 25.3803 32.6612C25.8817 32.6758 26.3798 32.5732 26.8375 32.361C27.2951 32.1489 27.7006 31.8327 28.0238 31.436L51.9995 2"
                  stroke="#09951F"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <h4 class="success-modal-green-text">Eligibility Confirmed</h4>
              <h4 class="success-modal-green-text">
                Click to Register Patient
              </h4>
            </div>
          </div>

          <h5
            class="text-center col-md-12 pointer text-end"
            @click="dialog = false"
          >
            Close
          </h5>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model.trim="dialog1"
      height="293"
      width="400"

    >
      <v-card>
        <v-card-text>
          <div class="col-md-12">
            <div class="row text-center justify-center">
              <h3 class="text-center mt-5 mb-5 text-underline black--text">
                Eligibility Check
              </h3>
            </div>
          </div>

          <div class="col-md-12 text-center mt-3">
            <div class="red-error-modal">
              <svg
                class="mt-1"
                width="44"
                height="44"
                viewBox="0 0 54 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.7713 5.74543C24.1794 6.19751 24.6778 6.55892 25.2344 6.80627C25.7909 7.05363 26.3931 7.18144 27.0021 7.18144C27.6111 7.18144 28.2133 7.05363 28.7698 6.80627C29.3263 6.55892 29.8248 6.19751 30.2329 5.74543L32.3216 3.42968C32.9244 2.76457 33.718 2.30209 34.5938 2.10559C35.4696 1.90908 36.3847 1.98815 37.2138 2.33198C38.0429 2.6758 38.7455 3.26755 39.2253 4.02621C39.7052 4.78487 39.9388 5.67334 39.8942 6.56994L39.7342 9.68131C39.7033 10.2898 39.8003 10.898 40.0191 11.4667C40.2378 12.0353 40.5734 12.5518 41.0042 12.9826C41.435 13.4134 41.9513 13.7491 42.5198 13.9679C43.0884 14.1867 43.6965 14.2837 44.3049 14.2528L47.4157 14.0928C48.3145 14.0449 49.2061 14.2769 49.9676 14.7569C50.7291 15.2368 51.3231 15.941 51.6679 16.7725C52.0127 17.6041 52.0913 18.5221 51.8929 19.4002C51.6945 20.2783 51.2287 21.0732 50.5599 21.6756L48.2445 23.7647C47.7925 24.1729 47.4312 24.6714 47.1839 25.228C46.9366 25.7847 46.8088 26.387 46.8088 26.9961C46.8088 27.6052 46.9366 28.2075 47.1839 28.7641C47.4312 29.3208 47.7925 29.8193 48.2445 30.2275L50.5599 32.3165C51.2275 32.9189 51.6922 33.7132 51.8902 34.5904C52.0882 35.4676 52.0098 36.3846 51.6657 37.2155C51.3216 38.0463 50.7287 38.7501 49.9685 39.2303C49.2083 39.7105 48.3181 39.9435 47.4202 39.8972L44.3094 39.7372C43.701 39.7066 43.0931 39.8039 42.5247 40.0228C41.9563 40.2417 41.4401 40.5774 41.0094 41.0081C40.5787 41.4389 40.2431 41.9552 40.0243 42.5237C39.8054 43.0922 39.7081 43.7002 39.7387 44.3087L39.8987 47.42C39.9449 48.3181 39.712 49.2085 39.2319 49.9688C38.7518 50.7292 38.0481 51.3222 37.2174 51.6663C36.3867 52.0105 35.4699 52.0889 34.5929 51.8909C33.7158 51.6928 32.9216 51.228 32.3194 50.5603L30.2307 48.2445C29.8225 47.7925 29.3241 47.431 28.7676 47.1837C28.2111 46.9363 27.6089 46.8085 26.9999 46.8085C26.3909 46.8085 25.7886 46.9363 25.2321 47.1837C24.6756 47.431 24.1772 47.7925 23.7691 48.2445L21.6737 50.5625C21.0714 51.2302 20.2772 51.6951 19.4002 51.8931C18.5232 52.0912 17.6063 52.0127 16.7757 51.6685C15.945 51.3244 15.2413 50.7314 14.7612 49.971C14.2811 49.2107 14.0481 48.3203 14.0944 47.4222L14.2544 44.3109C14.2853 43.7024 14.1883 43.0941 13.9695 42.5255C13.7508 41.9568 13.4152 41.4404 12.9844 41.0096C12.5537 40.5787 12.0373 40.2431 11.4688 40.0243C10.9002 39.8055 10.2921 39.7084 9.68371 39.7394L6.57289 39.8994C5.67751 39.9419 4.79083 39.707 4.03398 39.2266C3.27713 38.7462 2.687 38.0439 2.34423 37.2155C2.00145 36.3871 1.92273 35.473 2.11883 34.5982C2.31492 33.7233 2.77627 32.9304 3.43985 32.3277L5.75519 30.2386C6.20719 29.8304 6.56853 29.3319 6.81585 28.7753C7.06316 28.2186 7.19095 27.6163 7.19095 27.0072C7.19095 26.3981 7.06316 25.7958 6.81585 25.2392C6.56853 24.6825 6.20719 24.184 5.75519 23.7758L3.43985 21.6868C2.77136 21.0846 2.30584 20.2901 2.10731 19.4124C1.90878 18.5348 1.98701 17.6172 2.33123 16.7859C2.67544 15.9546 3.26874 15.2503 4.0295 14.7701C4.79027 14.2898 5.68113 14.0571 6.57955 14.1039L9.69037 14.2639C10.2999 14.296 10.9094 14.1994 11.4792 13.9805C12.0489 13.7616 12.5663 13.4252 12.9976 12.9932C13.4289 12.5612 13.7644 12.0432 13.9825 11.473C14.2006 10.9028 14.2962 10.2931 14.2633 9.68353L14.1033 6.57216C14.0603 5.67644 14.2948 4.78927 14.7749 4.03191C15.255 3.27455 15.9573 2.68395 16.7856 2.34082C17.614 1.99769 18.5281 1.91878 19.403 2.11487C20.2779 2.31095 21.0709 2.77247 21.6737 3.43634L23.7713 5.74543Z"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M34 21L19 36"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 21L34 36"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="error-modal-red-text">
                Not Eligible - Verify Information
              </div>
              <div class="error-modal-red-text">
                and ReRun Eligibility Check
              </div>
            </div>
          </div>

          <h5
            class="text-center col-md-12 pointer text-end"
            @click="dialog1 = false"
          >
            Close
          </h5>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import api from "../../../services/api";
export default {
  data() {
    return {
      payerId: "",
      groupId: "",
      planId: "",
      memberId: "",
      dialog: false,
      info: null,
      dialog1: false,
    };
  },
  created() {
    // this.getInfo();
  },
  methods: {
    getInfo() {
      api()
        .get("/dpc/eligibility")
        .then((res) => {
          if (res) {
            this.payerId = res.data.payerId ? res.data.payerId : "/";
            this.memberId = res.data.memberId ? res.data.memberId : "/";
            this.planId = res.data.planId ? res.data.planId : "/";
            this.groupId = res.data.groupId ? res.data.groupId : "/";
          }
        });
    },
    check() {
      let data = {
        payerId: this.payerId,
        groupId: this.groupId,
        planId: this.planId,
        memberId: this.memberId,
      };
      api()
        .post("/dpc/eligibility", data)
        .catch((err) => {
          if (err) {
            this.dialog1 = true;
          }
          return;
        })
        .then((res) => {
          if (res) {
            this.info = res.data;
            this.dialog = true;
          }
        });
    },
  },
};
</script>